import { render, staticRenderFns } from "./ItsOrderCustomsApply.vue?vue&type=template&id=3bb3af82&scoped=true&"
import script from "./ItsOrderCustomsApply.vue?vue&type=script&lang=js&"
export * from "./ItsOrderCustomsApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb3af82",
  null
  
)

export default component.exports